import dayjs from 'dayjs';

const getOffsetByTimezoneName = (timeZone: string) =>
  (new Date(new Date().toLocaleString('en-US', { timeZone })).getTime() -
    new Date(new Date().toLocaleString('en-US', { timeZone: 'UTC' })).getTime()) /
  6e4;

export const getTimezonesWithUTC = () =>
  Intl.supportedValuesOf('timeZone')
    .map((timezone) => ({
      timezone,
      offset: getOffsetByTimezoneName(timezone),
    }))
    .sort((a, b) => (a.offset === b.offset ? a.timezone.localeCompare(b.timezone) : a.offset - b.offset));

export const getCurrentTimezone = () => dayjs.tz.guess();

export const formatOffset = (offset: number): string => {
  const firstNum = Math.floor(offset / 60);
  const secondNum = Math.abs(offset % 60);

  return `${firstNum >= 0 ? '+' : ''}${firstNum}${secondNum === 0 ? '' : `:${secondNum}`}`;
};

export const formatDisplayedTimezone = (timezone: string) => timezone.replace('_', ' ');
